// extracted by mini-css-extract-plugin
export var mainOverlay = "friendlyReminderOverlay-module--main-overlay--3HafE";
export var centeredContents = "friendlyReminderOverlay-module--centered-contents--uByzD";
export var backgroundImg = "friendlyReminderOverlay-module--background-img--3TNK6";
export var reminderText = "friendlyReminderOverlay-module--reminder-text--R2NLv";
export var buttonDiv = "friendlyReminderOverlay-module--button-div--1F6u1";
export var closeButton = "friendlyReminderOverlay-module--close-button--3Gaa5";
export var button = "friendlyReminderOverlay-module--button--1YLXv";